import e from "react";
import { mintelMint500 as c, cmGreen500 as i } from "mintel-tokens";
import { u as d } from "./ThemeProvider--i7ESlT5.es.js";
import { D as u } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as g } from "./index-BB-Wk85r.es.js";
import { g as p } from "./utils-Ci4OZEP4.es.js";
import './Ribbon.css';const b = "Ribbon-module__rectangle___Zwutv", _ = "Ribbon-module__triangle___NTHRF", t = {
  rectangle: b,
  triangle: _
}, f = ({
  children: n,
  color: o = null,
  darkBg: m
}) => {
  const l = d(), r = {
    compere: i,
    default: c
  }, a = o ?? r[l] ?? r.default, s = m ?? p(a, "Card.Ribbon");
  return /* @__PURE__ */ e.createElement("span", { className: t.ribbon }, /* @__PURE__ */ e.createElement("div", { className: t.rectangle, style: { backgroundColor: a } }, /* @__PURE__ */ e.createElement(u, { darkMode: s }, /* @__PURE__ */ e.createElement(g.Heading6, { oneLineTruncate: !0, responsive: !0, tagName: "span" }, n))), /* @__PURE__ */ e.createElement("div", { className: t.triangle }));
};
f.displayName = "Ribbon";
export {
  f as R
};
